"use client"

import { NavLink, useLocation } from "react-router";
import { useScreenSize } from "../../contexts/screenSizeContext";
import "./bottomNav.css";
import Icon from '../Icon';
import {
    faChartBar as barChart,
    faFlag as flag,
    faUsers as people,
    faUser as person,
    faCalendar as calendar,
    faCog as settings,
    faChartPie,
    faArrowTrendUp,
    faList
} from '@fortawesome/free-solid-svg-icons';
import useWheelId from "@/hooks/useWheelId";
import { useProfileModal } from "@/contexts/profileModalContext";

interface NavItem {
    href: string;
    label: string;
    icon: any;
    onClick?: () => void;
}



const BottomNav: React.FC = () => {
    const location = useLocation();
    const screenSize = useScreenSize();
    const wheelId = useWheelId();
    const { openProfile } = useProfileModal();

    const navItems: NavItem[] = [
        { href: `/${wheelId}`, label: "Я", icon: person },
        { href: `/${wheelId}/roles`, label: "Баланс", icon: faChartPie },
        // { href: `/${wheelId}/goals`, label: "Цели", icon: flag },
        { href: `/${wheelId}/growth`, label: "Рост", icon: faArrowTrendUp },
        { href: `/${wheelId}/lists`, label: "Списки", icon: faList },
        { href: `/${wheelId}/actions`, label: "График", icon: calendar },
        { href: "profile", label: "Профиль", icon: settings, onClick: openProfile },
    ];

    if (screenSize === "MOBILE") {
        return (
            <nav className="bottom-nav">
                {navItems.map((item) => (
                    item.onClick ? (
                        <div
                            key={item.href}
                            className={`bottom-nav-item ${location.pathname === item.href ? "active" : ""}`}
                            onClick={item.onClick}
                            style={{ cursor: "pointer" }}
                        >
                            <Icon icon={item.icon} />
                            <span className="bottom-nav-label">{item.label}</span>
                        </div>
                    ) : (
                        <NavLink
                            key={item.href}
                            to={item.href}
                            className={({ isActive }) => `bottom-nav-item ${isActive ? "active" : ""}`}
                            style={{ textDecoration: 'none' }}
                            end={item.href === `/${wheelId}`}
                        >
                            <Icon icon={item.icon} />
                            <span className="bottom-nav-label">{item.label}</span>
                        </NavLink>
                    )
                ))}
            </nav>
        );
    }

    return null;
};

export default BottomNav;
